import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-unsaved-changes-warning',
  templateUrl: './unsaved-changes-warning.component.html',
  styleUrls: ['./unsaved-changes-warning.component.css', '../confirm-modal/confirm-modal.component.css']
})
export class UnsavedChangesWarningComponent implements OnInit {

	message = 'You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.';

	constructor(
		// @Inject(MAT_DIALOG_DATA) public data,
		public dialogRef: MatDialogRef<UnsavedChangesWarningComponent>
	) { }

	ngOnInit() {
	}

}
